import {ConfigurationGroupNode} from "#pricing/nodes/configuration-group-node"
import {configuratorVariantSchema} from "#pricing/types/pricing-types"
import {PricingListNode, pricingListDefinition} from "#pricing/pricing-list-node"
import {registerPricingGraphNode} from "#pricing/pricing-node"

const configurationListDefinition = pricingListDefinition("ConfigurationList", ConfigurationGroupNode, configuratorVariantSchema)

@registerPricingGraphNode
export class ConfigurationList extends PricingListNode<ConfigurationGroupNode> {
    public override get definition() {
        return configurationListDefinition
    }
}
